"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AggregationInterval = void 0;
/**
 * An enum that represents different intervals which will be used to aggregate data.
 */
var AggregationInterval;
(function (AggregationInterval) {
    AggregationInterval["Second"] = "second";
    AggregationInterval["Minute"] = "minute";
    AggregationInterval["Hour"] = "hour";
    AggregationInterval["Day"] = "day";
    AggregationInterval["Week"] = "week";
    AggregationInterval["Month"] = "month";
    AggregationInterval["Quarter"] = "quarter";
    AggregationInterval["Year"] = "year";
    AggregationInterval["AllTime"] = "allTime";
})(AggregationInterval = exports.AggregationInterval || (exports.AggregationInterval = {}));
